window.am = window.am || {};

window.am.breadcrumb = new function () {
    var that = this;

    this.breadcrumbData= [];

    this.init = function () {
        if (that.breadcrumbData.length > 0) {
            return;
        }

        const breadcrumb = $('.breadcrumb-navigation-container');
        that.breadcrumbData = $.map(breadcrumb.find('.breadcrumb-link'), link => {
            const $link = $(link);
            return {
                position: parseInt($link.attr('data-index') || 0),
                name: $link.text().trim(),
                item: $link.attr('href')
            };
        });

        that.breadcrumbData.push({
            position: that.breadcrumbData.length + 1,
            name: $('.breadcrumb-title.breadcrumb-title--last').text().trim()
        })

        const breadcrumbList = {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: this.breadcrumbData.map(item => {
                const result = {
                    "@type": "ListItem",
                    position: item.position,
                    name: item.name,
                };
                if (item.item) {
                    result.item = `${window.location.protocol}//${window.location.host}` + item.item;
                }
                return result;
            })
        }

        const script = document.createElement("script");
        script.setAttribute("type", "application/ld+json");

        script.innerHTML = JSON.stringify(breadcrumbList, null, 2);

        document.head.appendChild(script);
    }
}

window.am.breadcrumb.init();